import * as React from 'react';
import { IRenderFunction } from 'office-ui-fabric-react/lib/Utilities';

/**
 * @internal
 */
export interface ICheckboxGroup {

}

/**
 * @internal
 */
export enum CheckboxGroupOptionRenderType {
  /**
  * User type will render persona for each option.
  */
  user,

  /**
   * File type will render file type icon and label for each option.
   */
  fileType,

  /**
   * Choice type will use normal Checkbox to render each option.
   */
  choice
}

/**
 * @internal
 */
export interface ICheckboxGroupProps {
  /**
   * Optional callback to access the ICheckboxGroup interface. Use this instead of ref for accessing
   * the public methods and properties of the component.
   */
  componentRef?: (component: ICheckboxGroup) => void;

  /**
   * className that will be add to the root of the checkboxGroup.
   */
  className?: string;

  /**
   * The options for the checkbox group.
   */
  options?: ICheckboxGroupOption[];

  /**
   * The key of the options that will be initially checked.
   */
  defaultCheckedKeys?: string[];

  /**
   * The key of the checked options. If you provide this, you must maintain check
   * state by observing onChange events and passing a new value in when changed.
   */
  checkedKeys?: string[];

  /**
   * A callback for receiving a notification when the checkbox has been changed.
   */
  onChange?: (ev: React.FormEvent<HTMLElement | HTMLInputElement>, option: ICheckboxGroupOption, checked: boolean) => void;
}

/**
 * @internal
 */
export interface ICheckboxGroupOption extends React.HTMLAttributes<HTMLElement | HTMLInputElement> {
  /**
   * A required key to uniquely identify the option.
   */
  key: string;

  /**
   * The label string for the option.
   */
  label: string;

  /**
   * Optional override of option render
   */
  onRenderLabel?: IRenderFunction<ICheckboxGroupOption>;

  /**
   * This value is maintained by the component and is accessible during onRenderLabel
   */
  checked?: boolean;

  /**
   * Default is choice. When type is user, we will render option using Persona.
   * When type is fileType, we will render file type icon and the file type label for each option.
   */
  renderType?: CheckboxGroupOptionRenderType;

  /**
   * The src of image for checkbox field and is accessible during onRenderLabel
   */
  imageSrc?: string;
}
